// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".hr--normal{border-bottom:1.5px solid #C3C9D5;width:100%}.hr--light{border-bottom:1.5px solid #E1E4EA;width:100%}.hr--vertical{border-right:1.5px solid #E1E4EA}\n", ""]);
// Exports
module.exports = exports;
